<a [ngClass]="getItemClass()"
   href="{{item.url}}"
   [cHtmlAttr]="item.attributes">
  <i *ngIf="helper.hasIcon(item)" [ngClass]="getLabelIconClass()"></i>
  <ng-container>{{ item.name }}</ng-container>
  <span *ngIf="helper.hasBadge(item)" [ngClass]="item | cSidebarNavBadge">{{ item.badge.text }}</span>
</a>
